import { ContentExclusiveFormValues } from '../pages/Content/Exclusive/ExclusiveCreate';

type HookProps = {
  data: ContentExclusiveFormValues;
  id?: string;
};

export default function useContentSubmit({ data, id }: HookProps) {
  const obj = {};
  const keysThatAreDelete = ['image_file', 'tooltip', 'requester'];
  Object.assign(obj, data);

  if (data['visibility'] === 'restricted' && data['groups']) {
    obj['groups'] = data['groups'].map(group => group.value || group);
  }

  if (data['visibility'] !== 'restricted' && data['groups']?.length) {
    delete obj['groups'];
  }
  if (!obj['image_file'] || obj['image_file'] === undefined) {
    obj['image_name'] = `Sebrae Minas - ${obj['title']}`;
    obj['image_toltip'] = `Sebrae Minas - ${obj['title']}`;
  }

  if (!obj['content_id']) obj['content_id'] = id;

  const list = Object.entries(obj).filter(([_, value]) => value !== null);
  const objWhioutNulls = Object.fromEntries(list);

  keysThatAreDelete.forEach(key => delete objWhioutNulls[key]);

  return { obj: objWhioutNulls };
}
